import docker from './docker.svg'
import git from './git.png'
import jest from './jest.svg'
import kafka from './kafka.svg'
import linux from './linux.png'
import postman from './postman.svg'
import python from './python.png'
import redis from './redis.svg'
import vscode from './vscode.png'
import github from './github_logo.svg'


const OTHERS = { docker, git, jest, kafka, linux, postman, python, redis, vscode, github }

export const OTHER_SKILLS_ARRAY = [docker, git, jest, kafka, linux, postman, python, redis, vscode];

export default OTHERS
